import { Pipe, PipeTransform } from '@angular/core';
import { HOSPITAL_INFO_KEYWORDS } from '../shared/data/hospitalInfoKeywords.data';


@Pipe({
  name: 'hospitalTitlecase',
  standalone: true,
})
export class HospitalTitlecasePipe implements PipeTransform {
  private readonly keywordSet = new Set(
    HOSPITAL_INFO_KEYWORDS.map((k:any) => k.toUpperCase())
  );

  transform(value: string | null | undefined): string {
    if (!value) return '';

    return value
      .split(' ')
      .map((word) => {
        const upper = word.toUpperCase();
        if (this.keywordSet.has(upper)) {
          return upper;
        }
        // titlecase standard: prima lettera maiuscola, resto minuscolo
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }
}

export { HOSPITAL_INFO_KEYWORDS };
